// extracted by mini-css-extract-plugin
module.exports =  {"warningAlert":"KsHA7RxZCJKHHVlSOYiZ"};